import { useEffect, useRef, useState } from "react";

export default function MobileViewPage({
  bannersImages = [
    "https://picsum.photos/id/1018/1200/800",
    "https://picsum.photos/id/1018/1200/800",
  ],
  companyName = "Sunrise Fitness",
  type = "restaurant", // activity / restaurant
  activityName = "Morning Yoga Class",
  dietaries = ["Vegan", "Gluten-Free", "Halal"],
  location = "Sector 18, Noida",
  openingHours = {
    monday: "Closed",
    tuesday: "10:00 AM - 01:00 PM",
    wednesday: "09:00 AM - 05:00 PM",
    thursday: "09:00 AM - 05:00 PM",
    friday: "09:00 AM - 05:00 PM",
    saturday: "09:00 AM - 05:00 PM",
    sunday: "Closed",
  },
  description = "<p>Welcome to Sunrise Fitness — your go-to spot for mindful movement and community wellness. This beginner-friendly morning yoga session focuses on gentle stretches, breathwork, and balance, helping you start the day feeling calm and energized. No prior experience required; all you need is a positive mindset and comfortable clothing.</p><p>Our certified instructors guide you through a relaxing flow with personalized attention, making it suitable for all ages. Mats are available on-site, and we recommend arriving 10 minutes early to settle in. Join us to recharge, connect, and grow stronger one breath at a time.</p>",
  mapImage = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14010.52079865763!2d77.3209552!3d28.5709304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce44c3c0b4e6f%3A0xb3f4e4c0187b3f3f!2sSector%2018%2C%20Noida!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin",
}) {
  const [index, setIndex] = useState(0);
  const trackRef = useRef(null);

  const total = bannersImages.length;

  const nextImage = () => setIndex((i) => (i + 1) % total);
  const prevImage = () => setIndex((i) => (i - 1 + total) % total);

  useEffect(() => {
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${index * 100}%)`;
    }
  }, [index]);

  /* Show more / less */
  const [expanded, setExpanded] = useState(false);
  const maxLen = 500;
  const plainText = description.replace(/<[^>]*>/g, "");
  const truncated =
    plainText.length > maxLen ? plainText.slice(0, maxLen) + "..." : plainText;

  const dayLabels = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const dayShortKeys = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const getHours = (idx) => {
    const fullKey = dayLabels[idx].toLowerCase();
    const shortKey = dayShortKeys[idx];
    return openingHours?.[fullKey] ?? openingHours?.[shortKey] ?? "Closed";
  };

  return (
    <>
      <style>{`
        .iphone {
          width: 390px;
          height: 790px;
          background: linear-gradient(145deg, #1c1c1e, #000);
          border-radius: 56px;
          padding: 12px;
          position: relative;
        }

        .screen {
          background: #fff;
          width: 100%;
          height: 100%;
          border-radius: 44px;
          overflow: hidden;
          position: relative;
        }

        .notch {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 220px;
          height: 34px;
          background: #000;
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
          z-index: 10;
        }

        .status-bar {
          position: absolute;
          top: 6px;
          left: 0;
          right: 0;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          color: #fff;
          z-index: 11;
        }

        .content {
          height: 100%;
          overflow: hidden;
          padding-bottom: 0;
          -ms-overflow-style: none; /* IE/Edge */
          scrollbar-width: none; /* Firefox */
        }
        .content::-webkit-scrollbar { /* Chrome/Safari */
          width: 0;
          height: 0;
        }

        .gallery {
          position: relative;
          height: 280px;
          overflow: hidden;
        }

        .gallery-track {
          display: flex;
          height: 100%;
          transition: transform 0.4s ease;
        }

        .gallery img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .gallery-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 34px;
          height: 34px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          border: none;
          font-size: 18px;
          cursor: pointer;
        }

        .gallery-btn.left { left: 12px; }
        .gallery-btn.right { right: 12px; }

        .gallery-count {
          position: absolute;
          bottom: 12px;
          right: 48px;
          background: #fff;
          color: rgb(249 115 22);
          padding: 4px 10px;
          border-radius: 14px;
          font-size: 12px;
        }

        .section { padding: 16px; }
        h1 { font-size: 22px; margin-bottom: 8px; }
        h3 { margin-top: 10px; font-size: 19px; font-weight: 600; }

        .details { 
          text-align: left; 
          display: flex; 
          flex-wrap: wrap; 
          gap: 8px; 
          padding: 0; 
          margin: 8px 0 0; 
          list-style: none;
        }
        .details li {
          background: rgb(255 237 213);
          color: #ff6600;
          padding: 6px 12px;
          border-radius: 16px;
          font-size: 12px;
          margin: 0;
        }

        .description {
          font-size: 14px;
          line-height: 1.5;
        }

        .toggle-link {
          color: rgb(249 115 22);
          font-size: 13px;
          cursor: pointer;
        }

        .hours-list { list-style: none; padding: 0; margin: 8px 0 0; }
        .hours-item { display: flex; justify-content: space-between; padding: 2px 0; }
        .hours-item .day { font-weight: 600; }
        .hours-item .time { text-align: right; }
        .icons {position: absolute; bottom: 12px; right: 12px; width: 28px; height: 28px; background: #ffffff; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: rgb(249 115 22 / 74%); cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.15); z-index: 999;}
      `}</style>

      <div className="iphone" id="iphone-mockup">
        <div className="screen">
          <div className="notch"></div>

          <div className="status-bar">
            <div>9:41</div>
            <div>🔋</div>
          </div>

          <div className="content">
            {/* Gallery */}
            <div className="gallery">
              <div className="gallery-track" ref={trackRef}>
                {bannersImages.map((img, i) => (
                  <img key={i} src={img} alt="" crossOrigin="anonymous" />
                ))}
              </div>

              {total > 1 && (
                <>
                  <button className="gallery-btn left" onClick={prevImage}>
                    ‹
                  </button>
                  <button className="gallery-btn right" onClick={nextImage}>
                    ›
                  </button>
                  <div className="gallery-count">
                    {index + 1} / {total}
                  </div>
                </>
              )}

              <div className="icons">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-image-up"
                  aria-hidden="true">
                  <path d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21"></path>
                  <path d="m14 19.5 3-3 3 3"></path>
                  <path d="M17 22v-5.5"></path>
                  <circle cx="9" cy="9" r="2"></circle>
                </svg>
              </div>
            </div>

            <div className="section" style={{ color: "#000" }}>
              <h1>{companyName}</h1>

              {type === "activity" && <h4>{activityName}</h4>}

              {type === "restaurant" && (
                <>
                  <h3>Dietaries</h3>
                  {dietaries.length ? (
                    <ul className="details">
                      {dietaries.map((d, i) => (
                        <li key={i}>{d}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>Not specified</p>
                  )}
                </>
              )}

              <h3>Location</h3>
              <p className="description">{location}</p>

              {type === "restaurant" && (
                <>
                  <h3>Opening Hours</h3>
                  <ul className="hours-list">
                    {dayLabels.map((label, idx) => (
                      <li className="hours-item" key={label}>
                        <span className="day">{label}</span>
                        <span className="time">{getHours(idx)}</span>
                      </li>
                    ))}
                  </ul>
                </>
              )}

              {type === "activity" && (
                <>
                  <h3>Details</h3>
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: expanded ? description : truncated,
                    }}
                  />
                  {plainText.length > maxLen && (
                    <span
                      className="toggle-link"
                      onClick={() => setExpanded(!expanded)}
                    >
                      {expanded ? "Show less" : "Show more"}
                    </span>
                  )}
                </>
              )}

              {mapImage && (
                <iframe
                  src={mapImage}
                  width="100%"
                  height="200"
                  loading="lazy"
                  style={{ marginTop: 12, borderRadius: 12 }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
